import React from 'react';

import newTabIcon from 'assets/pics/newTab.png';
import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';
import { DividingLine } from 'components/DividingLine/DividingLine';

import { STAGE, STORAGE_KEY, TENANT_ID } from 'global/constants';

import { getStage } from 'utils/StageUtils';
import { getHomepageUrlByTenantId } from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

import { TenantSwitchSelectionButton } from './TenantSwitchSelectionButton';

import './TenantSwitchModal.sass';

export const TenantSwitchModal = ({ isOpen, onClose, links }) => {
  const currentTenantId = getTenantId();
  const stage = getStage();

  const prepareLink = (link) => {
    if (link.startsWith('https://') || link.startsWith('http://')) {
      return link;
    }
    return `https://${link}`;
  };
  const onTenantSwitchSimple = async (tenantId) => {
    if (tenantId === currentTenantId) {
      return;
    }
    const targetUrl = getHomepageUrlByTenantId(tenantId);

    if (stage === STAGE.LOCAL) {
      localStorage.setItem(STORAGE_KEY.TENANT_ID, tenantId);
    }

    window.location.replace(targetUrl);
  };

  const switchContent = () => (
    <div className="tenant-switch-modal__container">
      <div className="tenant-switch-modal__sub-text">
        Klicken Sie auf das Logo für den Wechsel zum e-Fix des Netzbetreibers:
      </div>
      <div className="tenant-switch-modal__tenant-button-container">
        <TenantSwitchSelectionButton
          tenant={TENANT_ID.EDI}
          onClick={() => onTenantSwitchSimple(TENANT_ID.EDI)}
          active={currentTenantId === TENANT_ID.EDI}
        />
        <TenantSwitchSelectionButton
          tenant={TENANT_ID.SHNG}
          onClick={() => onTenantSwitchSimple(TENANT_ID.SHNG)}
          active={currentTenantId === TENANT_ID.SHNG}
        />
        <TenantSwitchSelectionButton
          tenant={TENANT_ID.AVA}
          onClick={() => onTenantSwitchSimple(TENANT_ID.AVA)}
          active={currentTenantId === TENANT_ID.AVA}
        />
        <TenantSwitchSelectionButton
          tenant={TENANT_ID.BAG}
          onClick={() => onTenantSwitchSimple(TENANT_ID.BAG)}
          active={currentTenantId === TENANT_ID.BAG}
        />
        <TenantSwitchSelectionButton
          tenant={TENANT_ID.LVN}
          onClick={() => onTenantSwitchSimple(TENANT_ID.LVN)}
          active={currentTenantId === TENANT_ID.LVN}
        />
        <TenantSwitchSelectionButton
          tenant={TENANT_ID.MTN}
          onClick={() => onTenantSwitchSimple(TENANT_ID.MTN)}
          active={currentTenantId === TENANT_ID.MTN}
        />
      </div>

      {links?.length ? (
        <>
          <DividingLine />
          <div className="tenant-switch-modal__sub-text">
            Weitere Links zu Portalen von uns und unseren Schwesterunternehmen:
          </div>
          <div className="tenant-switch-modal__link-list">
            {links.map((link) => (
              <div key={link.urlTenantSwitch} className="tenant-switch-modal__link-item-container">
                <img
                  alt="new tab"
                  className="tenant-switch-modal__link-item-icon"
                  src={newTabIcon}
                />
                <a href={prepareLink(link.urlTenantSwitch)} target="_blank" rel="noreferrer">
                  <div className="tenant-switch-modal__link-item">{link.linkTitle}</div>
                </a>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );

  return (
    <CustomModal
      isOpen={isOpen}
      title="Portalwechsel"
      content={switchContent()}
      closeCancelEventModal={onClose}
      ctaButtons={<ActionButton title="Schließen" onClick={onClose} inverted />}
    />
  );
};

TenantSwitchModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      linkTitle: PropTypes.string.isRequired,
      urlTenantSwitch: PropTypes.string.isRequired,
    })
  ),
};

TenantSwitchModal.defaultProps = {
  links: [],
};
